export default __webpack_public_path__ + "static/media/news9.8d9a3ade.jpg";